module.exports = __webpack_public_path__ + "static/media/icon-sad.69be4450.svg";